import { useMsal } from '@azure/msal-react';
import { IdTokenClaims } from '@/types';
import {
  AccountInfo,
  InteractionStatus,
  IPublicClientApplication,
} from '@azure/msal-browser';

type MsalData = {
  instance: IPublicClientApplication;
  inProgress: InteractionStatus;
  accounts: AccountInfo[];
  idTokenClaims?: IdTokenClaims;
  hasLoggedIn: boolean;
};

export const useIdTokenClaims = (): MsalData => {
  const { instance, inProgress, accounts } = useMsal();
  const idTokenClaims = instance.getAllAccounts()[0]?.idTokenClaims as
    | IdTokenClaims
    | undefined;

  return {
    instance,
    inProgress,
    accounts,
    idTokenClaims,
    hasLoggedIn: !!idTokenClaims?.acr,
  };
};
